// import React, { useState, useEffect } from "react";
// import adminService from "../../Services/adminService";
// import toast from "react-hot-toast";
// import ExpenseDetailModal from "../../Components/Expensedetailmodal";

// const ProfitLoss = () => {
//   const [incomeData, setIncomeData] = useState(null);
//   const [expenseData, setExpenseData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [selectedHead, setSelectedHead] = useState(null);

//   const fetchData = async (start = "", end = "") => {
//     try {
//       setLoading(true);
//       const [income, expense] = await Promise.all([
//         adminService.totalIncome(start, end),
//         adminService.totalExpnse(start, end),
//       ]);
//       setIncomeData(income);
//       setExpenseData(expense);
//     } catch (error) {
//       toast.error("Error fetching P&L data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const handleFilter = () => {
//     if (startDate && endDate && startDate > endDate) {
//       toast.error("Start date cannot be after end date");
//       return;
//     }
//     fetchData(startDate, endDate);
//   };

//   const handleReset = () => {
//     setStartDate("");
//     setEndDate("");
//     fetchData();
//   };

//   // ── Income rows ──────────────────────────────────────────────
//   const patientSales = parseFloat(incomeData?.data?.patient_fee) || 0;
//   const serviceSales = parseFloat(incomeData?.data?.service_sales) || 0;
//   const medicineSales = parseFloat(incomeData?.data?.medicine_sales) || 0;

//   const incomeRows = [
//     { title: "Patient Fee", amount: patientSales },
//     { title: "Service Sales", amount: serviceSales },
//     { title: "Medicine Sales", amount: medicineSales },
//   ];

//   // ── Expense rows ─────────────────────────────────────────────
//   const expenseItems = (expenseData?.data?.expenses || []).filter(
//     (e) => e.expense_title.trim() !== "Grand Total",
//   );
//   const servicePurchase =
//     parseFloat(expenseData?.data?.purchases?.total_service_purchase) || 0;
//   const medicinePurchase =
//     parseFloat(expenseData?.data?.purchases?.total_medicine_purchase) || 0;

//   // isHead: true rows are backed by the expensehead table and can be
//   // clicked to view the underlying expense entries. Service/Medicine
//   // Purchase come from a separate purchases source, so they stay
//   // non-clickable for now.
//   const expenseRows = [
//     ...expenseItems.map((e) => ({
//       title: e.expense_title.trim(),
//       amount: parseFloat(e.total_amount) || 0,
//       isHead: true,
//     })),
//     { title: "Service Purchase", amount: servicePurchase, isHead: false },
//     { title: "Medicine Purchase", amount: medicinePurchase, isHead: false },
//   ];

//   // ── Calculations ─────────────────────────────────────────────
//   const totalIncome =
//     parseFloat(incomeData?.data?.total_sales) ||
//     incomeRows.reduce((s, r) => s + r.amount, 0);
//   const totalExpenses =
//     parseFloat(expenseData?.data?.total_expense) ||
//     expenseRows.reduce((s, r) => s + r.amount, 0);
//   const netProfit = totalIncome - totalExpenses;
//   const profitMargin =
//     totalIncome > 0 ? ((netProfit / totalIncome) * 100).toFixed(1) : 0;

//   // ── Net result rows (income - matching expense) ───────────────
//   const netRows = [
//     {
//       label: "Patient Fee",
//       income: patientSales,
//       expense: 0,
//       net: patientSales,
//     },
//     {
//       label: "Services",
//       income: serviceSales,
//       expense: servicePurchase,
//       net: serviceSales - servicePurchase,
//     },
//     {
//       label: "Medicines",
//       income: medicineSales,
//       expense: medicinePurchase,
//       net: medicineSales - medicinePurchase,
//     },
//   ];

//   // ── Helpers ───────────────────────────────────────────────────
//   const fmt = (n) =>
//     Math.abs(n).toLocaleString("en-PK", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });

//   const amountDisplay = (n) => (n < 0 ? `- Rs ${fmt(n)}` : `Rs ${fmt(n)}`);

//   // ── KPI cards ─────────────────────────────────────────────────
//   const kpiCards = [
//     {
//       label: "Total Income",
//       value: `Rs ${fmt(totalIncome)}`,
//       color: "text-green-700",
//       border: "border-green-200",
//     },
//     {
//       label: "Total Expenses",
//       value: `Rs ${fmt(totalExpenses)}`,
//       color: "text-red-700",
//       border: "border-red-200",
//     },
//     {
//       label: "Net Profit",
//       value: (netProfit < 0 ? "- " : "") + `Rs ${fmt(netProfit)}`,
//       color: netProfit >= 0 ? "text-green-700" : "text-red-700",
//       border: netProfit >= 0 ? "border-green-200" : "border-red-200",
//     },
//     {
//       label: "Profit Margin",
//       value: `${profitMargin}%`,
//       color: netProfit >= 0 ? "text-blue-700" : "text-red-700",
//       border: netProfit >= 0 ? "border-blue-200" : "border-red-200",
//     },
//   ];

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-6xl mx-auto p-4 space-y-6">
//       {/* Page title */}
//       <h1 className="text-xl font-semibold text-gray-800 text-center">
//         Profit & Loss Account
//       </h1>

//       {/* Date Filter */}
//       <div className="flex flex-wrap justify-end items-center gap-3">
//         <div className="flex items-center gap-1.5">
//           <label className="text-xs text-gray-500">From</label>
//           <input
//             type="date"
//             value={startDate}
//             onChange={(e) => setStartDate(e.target.value)}
//             className="text-xs border border-gray-200 rounded-lg px-2.5 py-1.5 text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-blue-100"
//           />
//         </div>
//         <div className="flex items-center gap-1.5">
//           <label className="text-xs text-gray-500">To</label>
//           <input
//             type="date"
//             value={endDate}
//             onChange={(e) => setEndDate(e.target.value)}
//             className="text-xs border border-gray-200 rounded-lg px-2.5 py-1.5 text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-blue-100"
//           />
//         </div>
//         <button
//           onClick={handleFilter}
//           disabled={!startDate && !endDate}
//           className="text-xs px-3 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
//         >
//           Search
//         </button>
//         {(startDate || endDate) && (
//           <button
//             onClick={handleReset}
//             className="text-xs px-3 py-1.5 rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors"
//           >
//             Reset
//           </button>
//         )}
//       </div>

//       {/* KPI Cards */}
//       <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
//         {kpiCards.map((card) => (
//           <div
//             key={card.label}
//             className={`rounded-xl border p-4 bg-white ${card.border}`}
//           >
//             <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">
//               {card.label}
//             </p>
//             <p className={`text-lg font-semibold leading-tight ${card.color}`}>
//               {card.value}
//             </p>
//           </div>
//         ))}
//       </div>

//       {/* Tables grid */}
//       <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
//         {/* Income Table */}
//         <div className="rounded-xl border h-fit border-gray-200 bg-white overflow-hidden">
//           <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100 bg-green-50">
//             <span className="w-2 h-2 rounded-full bg-green-600 flex-shrink-0" />
//             <span className="text-sm font-medium text-green-800">Income</span>
//           </div>
//           <table className="w-full text-sm">
//             <thead>
//               <tr className="border-b border-gray-100">
//                 <th className="text-left px-4 py-2 text-xs uppercase tracking-wide text-gray-400 font-medium">
//                   Title
//                 </th>
//                 <th className="text-right px-4 py-2 text-xs uppercase tracking-wide text-gray-400 font-medium">
//                   Amount (Rs)
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {incomeRows.map((row) => (
//                 <tr
//                   key={row.title}
//                   className="border-b border-gray-50 hover:bg-gray-50 transition-colors"
//                 >
//                   <td className="px-4 py-3 text-gray-800">{row.title}</td>
//                   <td className="px-4 py-3 text-right text-gray-700">
//                     {fmt(row.amount)}
//                   </td>
//                 </tr>
//               ))}
//               <tr className="bg-green-50">
//                 <td className="px-4 py-3 font-semibold text-green-800">
//                   Total Income
//                 </td>
//                 <td className="px-4 py-3 text-right font-semibold text-green-800">
//                   {fmt(totalIncome)}
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>

//         {/* Expense Table */}
//         <div className="rounded-xl border h-fit border-gray-200 bg-white overflow-hidden">
//           <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100 bg-red-50">
//             <span className="w-2 h-2 rounded-full bg-red-500 flex-shrink-0" />
//             <span className="text-sm font-medium text-red-800">Expenses</span>
//           </div>
//           <table className="w-full text-sm">
//             <thead>
//               <tr className="border-b border-gray-100">
//                 <th className="text-left px-4 py-2 text-xs uppercase tracking-wide text-gray-400 font-medium">
//                   Title
//                 </th>
//                 <th className="text-right px-4 py-2 text-xs uppercase tracking-wide text-gray-400 font-medium">
//                   Amount (Rs)
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {expenseRows.map((row, index) => (
//                 <tr
//                   key={`${row.title}-${index}`}
//                   onClick={() => row.isHead && setSelectedHead(row.title)}
//                   className={`border-b border-gray-50 transition-colors ${
//                     row.isHead
//                       ? "cursor-pointer hover:bg-blue-50"
//                       : "hover:bg-gray-50"
//                   }`}
//                   title={row.isHead ? "Click to view details" : undefined}
//                 >
//                   <td
//                     className={`px-4 py-3 ${
//                       row.isHead
//                         ? "text-blue-700 hover:underline"
//                         : "text-gray-800"
//                     }`}
//                   >
//                     {row.title}
//                   </td>
//                   <td className="px-4 py-3 text-right text-gray-700">
//                     {fmt(row.amount)}
//                   </td>
//                 </tr>
//               ))}
//               <tr className="bg-red-50">
//                 <td className="px-4 py-3 font-semibold text-red-800">
//                   Total Expenses
//                 </td>
//                 <td className="px-4 py-3 text-right font-semibold text-red-800">
//                   {fmt(totalExpenses)}
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>

//         {/* Net Result Table */}
//         <div className="rounded-xl border border-gray-200 h-fit bg-white overflow-hidden">
//           <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100 bg-blue-50">
//             <span className="w-2 h-2 rounded-full bg-blue-500 flex-shrink-0" />
//             <span className="text-sm font-medium text-blue-800">
//               Net Result
//             </span>
//           </div>
//           <table className="w-full text-sm">
//             <thead>
//               <tr className="border-b border-gray-100">
//                 <th className="text-left px-4 py-2 text-xs uppercase tracking-wide text-gray-400 font-medium">
//                   Item
//                 </th>
//                 <th className="text-right px-4 py-2 text-xs uppercase tracking-wide text-gray-400 font-medium">
//                   Amount (Rs)
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {netRows.map((row) => (
//                 <tr
//                   key={row.label}
//                   className="border-b border-gray-50 hover:bg-gray-50 transition-colors"
//                 >
//                   <td className="px-4 py-3 text-gray-800">{row.label}</td>
//                   <td
//                     className={`px-4 py-3 text-right font-medium ${
//                       row.net >= 0 ? "text-green-700" : "text-red-600"
//                     }`}
//                   >
//                     {amountDisplay(row.net)}
//                   </td>
//                 </tr>
//               ))}
//               {/* Net Profit footer */}
//               <tr
//                 className={`font-semibold ${netProfit >= 0 ? "bg-green-50" : "bg-red-50"}`}
//               >
//                 <td
//                   className={`px-4 py-3 ${netProfit >= 0 ? "text-green-800" : "text-red-800"}`}
//                 >
//                   Net Profit
//                 </td>
//                 <td
//                   className={`px-4 py-3 text-right ${netProfit >= 0 ? "text-green-800" : "text-red-800"}`}
//                 >
//                   {amountDisplay(netProfit)}
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Expense Detail Modal */}
//       {selectedHead && (
//         <ExpenseDetailModal
//           headTitle={selectedHead}
//           startDate={startDate}
//           endDate={endDate}
//           onClose={() => setSelectedHead(null)}
//         />
//       )}
//     </div>
//   );
// };

// export default ProfitLoss;
import React, { useState, useEffect } from "react";
import adminService from "../../Services/adminService";
import toast from "react-hot-toast";
import ExpenseDetailModal from "../../Components/Expensedetailmodal";

const ProfitLoss = () => {
  const [incomeData, setIncomeData] = useState(null);
  const [expenseData, setExpenseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedHead, setSelectedHead] = useState(null);

  const fetchData = async (start = "", end = "") => {
    try {
      setLoading(true);
      const [income, expense] = await Promise.all([
        adminService.totalIncome(start, end),
        adminService.totalExpnse(start, end),
      ]);
      setIncomeData(income);
      setExpenseData(expense);
    } catch (error) {
      toast.error("Error fetching P&L data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleFilter = () => {
    if (startDate && endDate && startDate > endDate) {
      toast.error("Start date cannot be after end date");
      return;
    }
    fetchData(startDate, endDate);
  };

  const handleReset = () => {
    setStartDate("");
    setEndDate("");
    fetchData();
  };

  const patientSales = parseFloat(incomeData?.data?.patient_fee) || 0;
  const serviceSales = parseFloat(incomeData?.data?.service_sales) || 0;
  const medicineSales = parseFloat(incomeData?.data?.medicine_sales) || 0;

  const incomeRows = [
    { title: "Patient Fee", amount: patientSales },
    { title: "Service Sales", amount: serviceSales },
    { title: "Medicine Sales", amount: medicineSales },
  ];

  const expenseItems = (expenseData?.data?.expenses || []).filter(
    (e) => e.expense_title.trim() !== "Grand Total",
  );
  const servicePurchase =
    parseFloat(expenseData?.data?.purchases?.total_service_purchase) || 0;
  const medicinePurchase =
    parseFloat(expenseData?.data?.purchases?.total_medicine_purchase) || 0;
  const expenseRows = [
    ...expenseItems.map((e) => ({
      title: e.expense_title.trim(),
      amount: parseFloat(e.total_amount) || 0,
      isHead: true,
    })),
    { title: "Service Purchase", amount: servicePurchase, isHead: true },
    { title: "Medicine Purchase", amount: medicinePurchase, isHead: false },
  ];

  const totalIncome =
    parseFloat(incomeData?.data?.total_sales) ||
    incomeRows.reduce((s, r) => s + r.amount, 0);
  const totalExpenses =
    parseFloat(expenseData?.data?.total_expense) ||
    expenseRows.reduce((s, r) => s + r.amount, 0);
  const netProfit = totalIncome - totalExpenses;
  const profitMargin =
    totalIncome > 0 ? ((netProfit / totalIncome) * 100).toFixed(1) : 0;
  const netRows = [
    {
      label: "Patient Fee",
      income: patientSales,
      expense: 0,
      net: patientSales,
    },
    {
      label: "Services",
      income: serviceSales,
      expense: servicePurchase,
      net: serviceSales - servicePurchase,
    },
    {
      label: "Medicines",
      income: medicineSales,
      expense: medicinePurchase,
      net: medicineSales - medicinePurchase,
    },
  ];

  const fmt = (n) =>
    Math.abs(n).toLocaleString("en-PK", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const amountDisplay = (n) => (n < 0 ? `- Rs ${fmt(n)}` : `Rs ${fmt(n)}`);

  const kpiCards = [
    {
      label: "Total Income",
      value: `Rs ${fmt(totalIncome)}`,
      color: "text-green-700",
      border: "border-green-200",
    },
    {
      label: "Total Expenses",
      value: `Rs ${fmt(totalExpenses)}`,
      color: "text-red-700",
      border: "border-red-200",
    },
    {
      label: "Net Profit",
      value: (netProfit < 0 ? "- " : "") + `Rs ${fmt(netProfit)}`,
      color: netProfit >= 0 ? "text-green-700" : "text-red-700",
      border: netProfit >= 0 ? "border-green-200" : "border-red-200",
    },
    {
      label: "Profit Margin",
      value: `${profitMargin}%`,
      color: netProfit >= 0 ? "text-blue-700" : "text-red-700",
      border: netProfit >= 0 ? "border-blue-200" : "border-red-200",
    },
  ];

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto p-4 space-y-6">
      <h1 className="text-xl font-semibold text-gray-800 text-center">
        Profit & Loss Account
      </h1>
      <div className="flex flex-wrap justify-end items-center gap-3">
        <div className="flex items-center gap-1.5">
          <label className="text-xs text-gray-500">From</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="text-xs border border-gray-200 rounded-lg px-2.5 py-1.5 text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-blue-100"
          />
        </div>
        <div className="flex items-center gap-1.5">
          <label className="text-xs text-gray-500">To</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="text-xs border border-gray-200 rounded-lg px-2.5 py-1.5 text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-blue-100"
          />
        </div>
        <button
          onClick={handleFilter}
          disabled={!startDate && !endDate}
          className="text-xs px-3 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          Search
        </button>
        {(startDate || endDate) && (
          <button
            onClick={handleReset}
            className="text-xs px-3 py-1.5 rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors"
          >
            Reset
          </button>
        )}
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {kpiCards.map((card) => (
          <div
            key={card.label}
            className={`rounded-xl border p-4 bg-white ${card.border}`}
          >
            <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">
              {card.label}
            </p>
            <p className={`text-lg font-semibold leading-tight ${card.color}`}>
              {card.value}
            </p>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <div className="rounded-xl border h-fit border-gray-200 bg-white overflow-hidden">
          <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100 bg-green-50">
            <span className="w-2 h-2 rounded-full bg-green-600 flex-shrink-0" />
            <span className="text-sm font-medium text-green-800">Income</span>
          </div>
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-100">
                <th className="text-left px-4 py-2 text-xs uppercase tracking-wide text-gray-400 font-medium">
                  Title
                </th>
                <th className="text-right px-4 py-2 text-xs uppercase tracking-wide text-gray-400 font-medium">
                  Amount (Rs)
                </th>
              </tr>
            </thead>
            <tbody>
              {incomeRows.map((row) => (
                <tr
                  key={row.title}
                  className="border-b border-gray-50 hover:bg-gray-50 transition-colors"
                >
                  <td className="px-4 py-3 text-gray-800">{row.title}</td>
                  <td className="px-4 py-3 text-right text-gray-700">
                    {fmt(row.amount)}
                  </td>
                </tr>
              ))}
              <tr className="bg-green-50">
                <td className="px-4 py-3 font-semibold text-green-800">
                  Total Income
                </td>
                <td className="px-4 py-3 text-right font-semibold text-green-800">
                  {fmt(totalIncome)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="rounded-xl border h-fit border-gray-200 bg-white overflow-hidden">
          <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100 bg-red-50">
            <span className="w-2 h-2 rounded-full bg-red-500 flex-shrink-0" />
            <span className="text-sm font-medium text-red-800">Expenses</span>
          </div>
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-100">
                <th className="text-left px-4 py-2 text-xs uppercase tracking-wide text-gray-400 font-medium">
                  Title
                </th>
                <th className="text-right px-4 py-2 text-xs uppercase tracking-wide text-gray-400 font-medium">
                  Amount (Rs)
                </th>
              </tr>
            </thead>
            <tbody>
              {expenseRows.map((row, index) => (
                <tr
                  key={`${row.title}-${index}`}
                  onClick={() => row.isHead && setSelectedHead(row.title)}
                  className={`border-b border-gray-50 transition-colors ${
                    row.isHead
                      ? "cursor-pointer hover:bg-blue-50"
                      : "hover:bg-gray-50"
                  }`}
                  title={row.isHead ? "Click to view details" : undefined}
                >
                  <td
                    className={`px-4 py-3 ${
                      row.isHead
                        ? "text-blue-700 hover:underline"
                        : "text-gray-800"
                    }`}
                  >
                    {row.title}
                  </td>
                  <td className="px-4 py-3 text-right text-gray-700">
                    {fmt(row.amount)}
                  </td>
                </tr>
              ))}
              <tr className="bg-red-50">
                <td className="px-4 py-3 font-semibold text-red-800">
                  Total Expenses
                </td>
                <td className="px-4 py-3 text-right font-semibold text-red-800">
                  {fmt(totalExpenses)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="rounded-xl border border-gray-200 h-fit bg-white overflow-hidden">
          <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100 bg-blue-50">
            <span className="w-2 h-2 rounded-full bg-blue-500 flex-shrink-0" />
            <span className="text-sm font-medium text-blue-800">
              Net Result
            </span>
          </div>
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-100">
                <th className="text-left px-4 py-2 text-xs uppercase tracking-wide text-gray-400 font-medium">
                  Item
                </th>
                <th className="text-right px-4 py-2 text-xs uppercase tracking-wide text-gray-400 font-medium">
                  Amount (Rs)
                </th>
              </tr>
            </thead>
            <tbody>
              {netRows.map((row) => (
                <tr
                  key={row.label}
                  className="border-b border-gray-50 hover:bg-gray-50 transition-colors"
                >
                  <td className="px-4 py-3 text-gray-800">{row.label}</td>
                  <td
                    className={`px-4 py-3 text-right font-medium ${
                      row.net >= 0 ? "text-green-700" : "text-red-600"
                    }`}
                  >
                    {amountDisplay(row.net)}
                  </td>
                </tr>
              ))}
              <tr
                className={`font-semibold ${netProfit >= 0 ? "bg-green-50" : "bg-red-50"}`}
              >
                <td
                  className={`px-4 py-3 ${netProfit >= 0 ? "text-green-800" : "text-red-800"}`}
                >
                  Net Profit
                </td>
                <td
                  className={`px-4 py-3 text-right ${netProfit >= 0 ? "text-green-800" : "text-red-800"}`}
                >
                  {amountDisplay(netProfit)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {selectedHead && (
        <ExpenseDetailModal
          headTitle={selectedHead}
          startDate={startDate}
          endDate={endDate}
          onClose={() => setSelectedHead(null)}
        />
      )}
    </div>
  );
};

export default ProfitLoss;